export default {"componentDescription":"","propDescriptions":{},"classDescriptions":{},"slotDescriptions":{"root":""}};